<ng-template let-data #confirmTmp>
  <div
    class="confirm-modal"
    [class.confirm-modal--info]="data.variant === 'info'">
    <h1 mat-dialog-title class="confirm-modal__title">
      {{
        data.title ||
          ('confirm-modal.component.title' | localise: 'Are you sure?')
      }}
    </h1>

    @if (data.body || data.bodyText) {
      <div mat-dialog-content class="confirm-modal__content">
        @if (data.body) {
          <ng-container [ngTemplateOutlet]="data.body"></ng-container>
        }
        @if (data.bodyText) {
          <p class="confirm-modal__body-text">{{ data.bodyText }}</p>
        }
        @if (!!data.validator && !!data.validator()) {
          <p class="form-error-msg">
            {{ data.validator() }}
          </p>
        }
      </div>
    }

    <div mat-dialog-actions class="confirm-modal__actions">
      @if (!data.hideClose) {
        <button mat-button class="dialog-button" [mat-dialog-close]>
          {{
            data.cancelText ||
              ('confirm-modal.component.no_button' | localise: 'No')
          }}
        </button>
      }
      <button
        mat-button
        class="dialog-button dialog-button--primary"
        [disabled]="!!data.validator && !!data.validator()"
        [mat-dialog-close]="true"
        cdkFocusInitial>
        {{
          data.confirmText ||
            ('confirm-modal.component.ok_button' | localise: 'Ok')
        }}
      </button>
    </div>
  </div>
</ng-template>
